import type { RouteRecordRaw } from 'vue-router'
import { Layout } from '@/utils/routerHelper'

const prizeRoutes: RouteRecordRaw[] = [
  {
    path: '/prize',
    name: 'Prize',
    component: Layout,
    meta: {
      title: '奖品管理',
      icon: 'vi-ep:present',
      alwaysShow: true
    },
    children: [
      {
        path: 'type',
        component: () => import('@/views/Prize/PrizeTypeList.vue'),
        name: 'PrizeTypeList',
        meta: { title: '奖品类型' }
      },
      {
        path: 'record',
        component: () => import('@/views/Prize/PrizeRecordList.vue'),
        name: 'PrizeRecordList',
        meta: { title: '奖励记录' }
      },
      {
        path: 'rule',
        component: () => import('@/views/Prize/PrizeRuleList.vue'),
        name: 'PrizeRuleList',
        meta: { title: '奖励规则' }
      }
    ]
  }
]

export default prizeRoutes
